module.exports = __webpack_public_path__ + "img/6.2d564116.jpg";